<!-- <template>
    <div class="header">
        <div class="header-nav">
            <div class="wrapper">
                <div class="header-left">
                    <div class="nav-menu">
                        <router-link v-for="menu in menus" :to="menu.path" :key="menu.path" class="menu-item menu-li">{{$t('mall.'+menu.title)}}</router-link>
                    </div>
                   
                    <span style="display:inline-block;height:100%;width:180px;padding-left:10px">
                        <img  src="./images/logo.png" />
                    </span>
               
               
                </div>
                <div class="header-right">
                    <div class="nav-menu" v-if="ticketInfo.UserName">
                        <router-link class="menu-item menu-li" :to="{name:'UserMain'}" style="color: white">
                            <span class="index_exit" style="cursor: pointer">{{ticketInfo.UserName}}</span>
                        </router-link>
                        <span class="menu-item index_exit" style="cursor: pointer" @click="exit">{{$t('system.loginout')}}</span>
                    </div>
                    <div class="nav-menu" style="height:40px;" v-else>
                        <span @click="login" style="cursor: pointer;padding: 10px" class="index_login">{{$t('system.login')}}</span>
                        <span>/</span>
                        <router-link to="/User/Register" class="index_exit" style="cursor: pointer;padding: 10px">{{$t('system.registernow')}}</router-link>
                    </div>
                </div>
                <div style="float:right;margin-right: 10px">
                    <div>
                        <el-dropdown @command="changelang">
                            <span style="cursor: pointer;color: #fff;">{{$t('system.langsetting')}}</span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command='cn'>{{$t('system.china')}}</el-dropdown-item>
                                <el-dropdown-item command='en'>{{$t('system.english')}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .header-right {
        background-color: #FC6C26;
        text-align: center;
    }

    .index_login:hover {
        color: #6cb2d4;
    }

    .index_exit:hover {
        color: #6cb2d4;
    }

    .header-left a:hover,
    .header-left .router-link-exact-active {
        background-color: #084699;
    }
</style> -->
<template>
    <div class="header" :class="{'isIndex':$route.path=='/','isJapanese':$i18n.locale=='jp'}">
        <div class="wrapper">
            <div class="header-nav">
                <div class="header-nav-left">
                    <img v-if="$route.path=='/'" :src="getImgs('logo2.png')" />
                    <img v-else  :src="getImgs('logo.png')" >
                </div>
                <div class="header-nav-center">
                    <div class="nav-menu">
                        <router-link v-for="menu in menus" :to="menu.title=='mall.home'||menu.title=='mall.bookingcenter'||menu.title=='mall.btripplateform' ||menu.title=='mall.tourism'||menu.title=='mall.contactUs'?menu.path:''" :key="menu.path" class="menu-item menu-li">{{$t(menu.title)}}</router-link>
                        <!-- <router-link v-for="menu in menus" :to="menu.path" :key="menu.path" class="menu-item menu-li">{{$t(menu.title)}}</router-link> -->
                    </div>
                </div>
                <div class="header-nav-right">
                    <el-dropdown :style="{'color':$route.path!='/'?'#fff':'#323232'}" @command="changelang">
                        <span style="cursor: pointer">{{$t('system.langsetting')}}</span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command='cn'>{{$t('system.china')}}</el-dropdown-item>
                            <el-dropdown-item command='en'>{{$t('system.english')}}</el-dropdown-item>
                            <el-dropdown-item command='jp'>{{$t('system.japan')}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div class="ticketInfo" v-if="ticketInfo.UserName">
                        <router-link class="menu-item menu-li" :to="{name:'UserMain'}">
                            <span class="index_exit">{{ticketInfo.UserName}}</span>
                        </router-link>
                        <div></div>
                        <div class="menu-item index_exit" @click="exit">{{$t('system.loginout')}}</div>
                    </div>
                    <div class="ticketInfo" v-else>
                        <div @click="login" class="index_login">{{$t('system.login')}}</div>
                        <div></div>
                        <router-link to="/Company/Register" tag="div" class="index_exit">{{$t('system.registernow')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .isIndex .ticketInfo>div:first-child {
        border: 1px solid #666;
        box-sizing: border-box;
    }

    .isIndex .ticketInfo>div:nth-child(2) {
        border-left: 1px solid #aaaaaa;
        box-sizing: border-box;
    }

    .isIndex {
        top: 0;
        left: 0;
        z-index: 999;
        opacity: 2;
        position: fixed;
        background-color: #fff !important;
        color: #323232 !important;
    }

    .isIndex .header-nav a {
        color: #323232 !important;
    }

    .header-nav {
        font-size: 16px;
        align-items: center;
        overflow: hidden;
    }

    .header-nav-left {
        font-size: 0;
        width: 170px;
        float: left;
    }

    .header-nav-left img {
        height: 30px;
    }

    .header-nav-center {
        height: 30px;
        line-height: 30px;
        float: left;
    }

    .header-nav-right {
        display: flex;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        float: right;
    }

    .ticketInfo {
        display: flex;
    }

    .ticketInfo>div:first-child {
        border: 1px solid #fff;
        padding: 0 20px;
        border-radius: 5px;
        box-sizing: border-box;
    }



    .ticketInfo>div:last-child {
        padding: 0 20px;
        border-radius: 5px;
        background-color: #ee3148;
        color: #fff
    }

    .ticketInfo>div:first-child,
    .ticketInfo>div:last-child {
        margin: 0 15px;
        cursor: pointer;
    }

    .ticketInfo>div:nth-child(2) {
        border-left: 1px solid #fff;
        box-sizing: border-box;
    }

    .header a {
        color: #fff;
    }

    .isJapanese .menu-item {
        float: left;
        padding: 0 20px 0 15px;
    }

</style>
<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        data() {
            return {
                menus: [{
                    path: '/',
                    title: 'mall.home'
                }, {
                    path: '/mall/booking',
                    title: 'mall.bookingcenter'
                }, {
                    path: '/btripplatform/main',
                    title: 'mall.btripplateform'
                }, {
                    path: '/meeting/index',
                    title: 'mall.tourism'
                },
                //  {
                //     path: '/flight',
                //     title: 'mall.comcoop'
                // },
                  {
                    path: '/system/serve/contact',
                    title: 'mall.contactUs'
                }, {
                    path: '/train',
                    title: 'mall.appdownload'
                }]
            }
        },
        computed: {
            ...mapGetters(['ticketInfo'])
        },
        mounted() {
            var __self = this;
            var userStore = __self.$store.getters.getTicket;
        },
        methods: {
            exit() {
                var __self = this;
                __self.$store.dispatch("logout").then(function () {
                    location.href = "/"
                }).catch(function () {
                    location.href = "/"
                });
            },
            login() {
                this.$router.push({
                    path: '/login',
                    query: {
                        redirect: this.$route.fullPath
                    }
                });
            },
            changelang(value) {
                window.localStorage.setItem('lang', value);
                this.$i18n.locale = value;
                // window.location.reload();
            }
        }
    }

</script>



// WEBPACK FOOTER //
// header.vue?7cb2094e